export default __webpack_public_path__ + "static/plant-facility-9d976d6a0fda45a48725938a10e47670.jpeg";